const strings = {
  en: {
    heading: 'Clients of MampuAI',
    label: 'Trusted by',
  },
  zh: {
    heading: 'Mampu AI 客户',
    label: '值得信赖的合作伙伴',
  },
};

export default strings;
